<template>
	<div class="text-field display-flex" ref="textFieldContainer">
		<input
			ref="text"
			:v-focus="autofocus"
			:autofocus="autofocus"
			@keyup.stop.capture.prevent="onKey"
			@keydown.stop.capture="onKeyDown"
			v-model="localValue"
			:type="type"
			:placeholder="placeholder"
			:readonly="readonly"
			:maxlength="isPiggyback ? 30 : null"
			name="text"
		/>
		<label v-if="isPiggyback" :class="{ 'is-input-disabled': isInputDisabled }" class="word-counter" for="text">{{ wordCount }}</label>
	</div>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';

const MAX_LENGTH_FOR_ON_SEND_CHECKBOX = 30;

export default {
	name: 'TextField',
	mixins: [VModelMixin],
	props: {
		type: { type: String, default: 'text' },
		placeholder: { type: String },
		autofocus: {
			type: Boolean,
			default: false,
		},
		readonly: { type: Boolean, default: false },
		isPiggyback: { type: Boolean, default: false },
	},
	directives: {
		focus: {
			// directive definition
			inserted(el) {
				el.focus();
			},
		},
	},
	computed: {
		isInputDisabled() {
			return this.localValue?.length >= MAX_LENGTH_FOR_ON_SEND_CHECKBOX;
		},
		wordCount() {
			return `${String(this.localValue.length)} / ${MAX_LENGTH_FOR_ON_SEND_CHECKBOX}`;
		},
	},
	methods: {
		onKey($e) {
			// $e.preventDefault();
			$e.stopPropagation();
			return false;
		},
		onKeyDown($e) {
			// console.log(`onKeyDown hey: `, $e);
			// console.log($e);
			// $e.preventDefault();
			$e.stopPropagation();
			return false;
		},
	},
	mounted() {
		if (this.autofocus) {
			this.$nextTick(() => {
				this.$refs['text'].click();
				this.$refs['text'].focus();
			});
		}
		// this.$refs['text'].addEventListener(
		// 	'keydown',
		// 	function ($e) {
		// 		console.log('text:', $e);
		// 		$e.stopPropagation();
		// 		return false;
		// 	},
		// 	false
		// );

		// this.$refs['textFieldContainer'].addEventListener('keydown', function ($e) {
		// 	console.log('textFieldContainer:', $e);
		// 	$e.stopPropagation();
		// 	return false;
		// });
	},
};
</script>
<style scoped lang="scss">
.text-field {
	padding: 10px 8px;
	background-color: var(--bg-color);
	border-radius: var(--border-radius);
	border: var(--primary-border);

	input {
		width: 100%;
		color: var(--input-text-color);
		outline: none !important;
		font-size: var(--font-size-4);
	}
	.word-counter {
		white-space: nowrap;
	}
	.is-input-disabled {
		color: red;
	}
}
</style>
